import { render, staticRenderFns } from "./LargeAmountMoneyPaySetting.vue?vue&type=template&id=3e865f35&scoped=true"
import script from "./LargeAmountMoneyPaySetting.vue?vue&type=script&lang=js"
export * from "./LargeAmountMoneyPaySetting.vue?vue&type=script&lang=js"
import style0 from "./LargeAmountMoneyPaySetting.vue?vue&type=style&index=0&id=3e865f35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e865f35",
  null
  
)

export default component.exports